<template>
<img :src="path" :width="size" class="loader-svg">
</template>

<script>
export default {
    props: {
        /**
         * Specify loader color. Allowed: ripple, ripple-light.
         */
        color: {
            default: 'ripple',
        },

        /**
         * Specify loader size.
         */
        size: {
            default: '18px',
        },
    },

    computed: {
        path() {
            return '/img/web/loaders/tail-spin/' + this.color + '.svg';
        },
    },
}
</script>
